import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import Status from '../Helper/Status'
import AbstractEntity from '../Entity/AbstractEntity'

/**
* Class UniteProjet
* UniteProjet view component
**/
class UniteProjet extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "UniteProjet";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return <div></div>;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de unité.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idUniteProjet" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idUniteProjet")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idUniteProjet";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    const uniteObj = cloneObject(this.state.object);

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(uniteObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Unité sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);

        const state = {
          status: {
            type: 'success',
            message: 'Unité créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/uniteProjets/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default UniteProjet;



// WEBPACK FOOTER //
// ./src/views/Entity/UniteProjet.js